<template>
    <div id="current-subscription">
        <div class="usage">
            <h3>{{$t('subscription.usage')}}</h3>
            <div class="content">
                <div class="generation-count">
                    <span class="title">{{$t('subscription.generations')}}</span>
                    <progress-circle 
                        class="generation-counter" 
                        :maxAmount="parseInt(subscription.custom_fields.generation_limit)" 
                        :activeAmount="parseInt(generationCount.toFixed())"
                        :circleSize="90"
                        :strokeWidth="4"
                        :textSize="18"
                    />
                    <usage-counter
                        :usageAmount="parseInt(generationCount.toFixed())"
                        :maxAmount="subscription.custom_fields.generation_limit"
                        :dangerZone="80" 
                    >
                </usage-counter>
                </div>

                <usage-counter
                    :title="$t('subscription.integrations')"
                    :usageAmount="integrationCount"
                    :maxAmount="subscription.custom_fields.integration_limit"
                    :dangerZone="80" 
                >
                    <i slot="icon" class="fa-light fa-database usage-icon"></i>
                </usage-counter>

                 <usage-counter
                    :title="$t('subscription.users')"
                    :usageAmount="userCount"
                    :maxAmount="subscription.custom_fields.users_limit"
                    :dangerZone="80" 
                >
                    <i slot="icon" class="fa-light fa-user usage-icon"></i>
                </usage-counter>

                 <usage-counter
                    :title="$t('subscription.templates')"
                    :usageAmount="templateCount"
                    :maxAmount="subscription.custom_fields.template_limit"
                    :dangerZone="80" 
                >
                    <i slot="icon" class="fa-light fa-file usage-icon"></i>
                </usage-counter>
                 <usage-counter
                    :title="$t('subscription.publications')"
                    :usageAmount="publicationCount"
                    :dangerZone="80" 
                >
                    <i slot="icon" class="fa-light fa-file-export usage-icon"></i>
                </usage-counter>
            </div>
        </div>
        <div class="payment">
            <h3>{{$t('subscription.payment')}}</h3>
            <div class="content">
                <div class="credit-card" v-if="subscription.collection_method == 'payment_card'">
                    <h3>{{$t('subscription.card')}}</h3>
                    <div class="card-info">
                        <i class="fa-light fa-credit-card"></i>
                        <div>
                            <span>{{subscription.po_number}}</span>
                            <span class="expiration">{{$t('subscription.expires')}} {{new Date(subscription.end_date ) | dateFormat('MM/YY')}}</span>
                        </div>
                    </div>
                </div>
                
                <div class="invoice" v-else>
                    Invoice payment
                </div>
                    
                <p class="next-payment">{{$t('subscription.next-payment1')}} <span>{{subscription.terms.price}}.- </span>{{$t('subscription.next-payment2')}} <span>{{new Date( subscription.next_renewal_date ) | dateFormat('DD/MM/YYYY')}}</span></p>
                <button class="btn btn-primary">{{subscription.collection_method == 'payment_card' ?  $t('subscription.update-card') : $t('subscription.add-card')}}</button>
            </div>
        </div>
        <div class="current-plan">
            <h3>{{$t('subscription.current-plan')}}</h3>
            <div class="content">
               <h3>{{subscription.plan.name}}</h3>
               <p>Description of the plan that is subscribed to. 
                   underneath the user will have a view of what the subscription consists of</p>
                <div class="plan-terms">
                    <div class="plan-term">
                        <i class="fa-light fa-sync-alt"></i>
                        <p>{{$t('subscription.up-to')}} <span>{{subscription.custom_fields.generation_limit}}</span> {{$t('subscription.generations')}}</p>
                    </div>
                    <div class="plan-term">
                        <i class="fa-light fa-database"></i>
                        <p>{{$t('subscription.max')}} <span>{{subscription.custom_fields.integration_limit}}</span> {{$t('subscription.integrations')}} </p>
                    </div>
                    <div class="plan-term">
                        <i class="fa-light fa-file"></i>
                      <p>{{$t('subscription.max')}} <span>{{subscription.custom_fields.template_limit}}</span> {{$t('subscription.templates')}}</p>
                    </div>
                    <div class="plan-term">
                        <i class="fa-light fa-user"></i>
                       <p>{{$t('subscription.up-to')}} <span>{{subscription.custom_fields.users_limit}}</span> {{$t('subscription.users')}}</p>
                    </div>
                    <div class="plan-term">
                        <i class="fa-light fa-headset"></i>

                        <!-- <i class="fa-light fa-play-circle"></i> -->
                      <!-- <p> <span>{{subscription.custom_fields.workshop_hours}}</span> hours onboarding </p> -->
                      <p>Live support</p>
                    </div>
                </div>
                
                <div class="bottom-section">
                    <div class="actions">
                        <button class="btn btn-primary" @click="$emit('change-subscription')">{{$t('subscription.change-plan')}}</button>
                        <button class="btn btn-secondary" @click="$emit('change-subscription')">{{$t('subscription.cancel-plan')}}</button>
                    </div>

                    <div class="price">
                        <span> {{subscription.terms.currency}}</span>
                        <span> {{subscription.terms.price}}.-</span>
                    </div>

                </div>
               
            </div>
        </div>
        <div class="reciepts">
            <h3>{{$t('subscription.reciepts')}}</h3>
            <div class="content">
                list of reciepts
            </div>
        </div>
    </div>
</template>

<script>
import ProgressCircle from '@/components/ProgressCircle'
import AnimateText from '@/components/AnimateText'
import UsageCounter from '@/components/UsageCounter'
export default {
name: 'SubscriptionOverview',
  data() {
    return {

    }

  },
  props:{
      subscription: Object
  },
  methods:{

  },
 
  computed:{
      templateCount(){
          return this.$store.state.templates.filter(t => !t.published).length
      },
      publicationCount(){
          return this.$store.state.templates.filter(t => t.published).length
      },
      userCount(){
          return this.$store.state.users.length
      },
      integrationCount(){
          return this.$store.state.contentTypes.length
      },
      generationCount(){
          return Math.random() * 5000  
        //   return 5000
      }
  },
  components: {
   ProgressCircle,
   AnimateText,
   UsageCounter
  }

};
</script>

<style lang="less">
#current-subscription{
    display: grid;
    grid-template-columns: 2fr 1fr;
    // grid-auto-rows: 1fr;
    gap: 20px;
    > div{
        > h3{
            padding: 0 0 20px 20px;
            margin: 0;
            font-size: 18px;
            font-weight: normal;
        
        }
        
    }
    .content{
        height: calc(100% - 41px);
        padding: 20px;
        background: #fff;
        box-shadow: 0px 6px 16px -5px #00000026;

        .usage-icon{
            width: 20px;
            font-size: 20px;
        }
    }
    .usage{
        .content{
            display: grid;
            grid-template-columns: repeat(4, auto);
            grid-auto-rows: auto;
            gap: 12px;
            & > div{
                gap: 12px;
                align-items: center;
                // margin: 20px;
            }
        }

        .generation-count{
            grid-row-end:  span 2;
            display: flex;
            flex-direction: column;
        }

        .title{
            font-size: 14px;
            font-weight: bold;
        }
    }

    .payment{
        .content{
            // height: calc(100% - 41px);
               .next-payment{
                font-size: 12px;
                margin: 12px 0;
                span{
                    font-weight: bold;
                }
            }
            .credit-card{
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                h3{
                    font-size: 14px;
                    font-weight: bold;
                }
                button{
                    width: max-content;
                }
                .card-info{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 12px;
                    svg{
                        font-size: 18px;
                    }
                    div{
                        display: flex;
                        flex-direction: column;

                        .expiration{
                            font-size: 10px;
                            opacity: .7;
                        }
                    }
                }
            }
        }
    
    }

    .current-plan{
      .content  h3{
            font-size: 18px;
            font-weight: bold;
        }
        .plan-terms{
            display: grid;
            grid-template-columns: repeat(3, auto);
            grid-auto-rows: auto;
                gap: 12px;
            .plan-term{
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 12px;
                p{
                    margin: 0;
                    span{
                        font-weight: bold;
                    }
                }
            }
        }
        .bottom-section{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 20px 0 0 0;
            
            button{
                margin-right: 12px;
            }
        }
        .price{
            font-size: 18px;
            font-weight: bold;
        }
    }
}

@media only screen and (max-width: 1100px){
    #current-subscription{
        grid-template-columns: 1fr;
    }
}
@media only screen and (max-width: 575px){
    #current-subscription{
        .usage{
            .content{
                grid-template-columns: 1fr;
                div{
                    text-align: center; 
                    justify-content: center;

                }
            }
        } 
        .current-plan{
            .plan-terms{
                grid-template-columns: 1fr;
            } 
            .bottom-section{
                flex-direction: column-reverse;
            }
        }
    } 
}
</style>
